export const Urls = {
    GetMe: "me",
    DoesUserExist: "me/DoesUserExist",
    GetMyAccessibleDepartments: "me/getMyAccessibleDepartments",
    SwitchMe: "me/switchRole",
    ActivateUser: "me/activateUser"
};
